import type { FilterField } from '@/components/ui/filter-bar';
import type { DateRange } from './gift-cards.api';

/**
 * The From/To pair every gift-card tab carries.
 *
 * Its own module rather than a second export from `tab-shell`: mixing a
 * helper in beside components is what breaks fast refresh for the whole file.
 */

export function dateFields(
  dates: DateRange,
  onChange: (next: DateRange) => void,
  t: (key: string) => string
): FilterField[] {
  return [
    {
      id: 'start',
      label: t('giftCards.from'),
      type: 'date',
      value: dates.start,
      // A range field is never "not filtering", so it carries no reset value
      // and never counts towards the mobile Filters badge.
      resetValue: dates.start,
      onChange: (value) => onChange({ ...dates, start: value }),
    },
    {
      id: 'end',
      label: t('giftCards.to'),
      type: 'date',
      value: dates.end,
      resetValue: dates.end,
      onChange: (value) => onChange({ ...dates, end: value }),
    },
  ];
}
